import React from 'react';

const FormField = ({ 
  label, 
  value, 
  onChange, 
  placeholder, 
  type = 'text', 
  options = [], 
  isTextarea = false,
  hasCustomInput = false,
  customValue = '',
  onCustomChange,
  customPlaceholder = ''
}) => {
  return (
    <div className="mb-6">
      <label className="block text-white font-medium mb-2">
        {label}
      </label>
      
      {type === 'select' ? (
        <div>
          <select 
            value={value} 
            onChange={(e) => onChange(e.target.value)}
            className="w-full py-3 px-4 clay-input clay-select text-white highlight-hover"
          >
            <option value="">{placeholder}</option>
            {options.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
          
          {hasCustomInput && (
            <input
              type="text"
              value={customValue}
              onChange={(e) => onCustomChange(e.target.value)}
              placeholder={customPlaceholder}
              className="w-full py-3 px-4 mt-2 clay-input text-white highlight-hover"
            />
          )}
        </div>
      ) : isTextarea ? (
        <textarea 
          value={value} 
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          rows="4"
          className="w-full py-3 px-4 clay-input text-white highlight-hover"
        />
      ) : (
        <input 
          type={type}
          value={value} 
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          className="w-full py-3 px-4 clay-input text-white highlight-hover"
        />
      )}
    </div>
  );
};

export default FormField;